import { Button, Col, Row } from "antd";
import { DragOutlined } from "@ant-design/icons";
import { useDrag, useDrop } from "react-dnd";

import ComponentPlacesAutocomplete from "../../../map/PlaceAutocomplete";

interface reducerAction {
  type: string;
  value?: string;
  data?: any;
  newState?: any;
  fromIndex?: number;
  toIndex?: number;
}

interface DraggableDestinationProps {
  index: number;
  id: string;
  destination: any;
  dispatchUserData: (action: reducerAction) => void;
  destinationLabel: string;
  moveDestination: (dragIndex: number, hoverIndex: number) => void;
}

const DraggableDestination = ({
  index,
  id,
  destination,
  dispatchUserData,
  destinationLabel,
  moveDestination,
}: DraggableDestinationProps) => {
  const [{ isDragging }, drag] = useDrag({
    type: "destination",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: "destination",
    hover: (item: { index: number }) => {
      if (item.index === index) {
        return;
      }
      moveDestination(item.index, index);
      item.index = index;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <div
      ref={(node) => drag(drop(node))}
      style={{
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: isOver ? "#f0f0f0" : "transparent",
        padding: "12px",
        marginBottom: "8px",
        border: "1px solid #d9d9d9",
        borderRadius: "6px",
        cursor: "move",
      }}
    >
      <Row gutter={[16, 16]} align="middle">
        <Col flex="none">
          <DragOutlined style={{ color: "#999", fontSize: "16px" }} />
        </Col>
        <Col flex="auto">
          <div
            style={{ marginBottom: "4px", fontWeight: "500", color: "#666" }}
          >
            {destinationLabel}
          </div>
          <ComponentPlacesAutocomplete
            key={id}
            type="multi"
            callback={(data: any) => {
              dispatchUserData({
                type: "EDIT_DESTINATION",
                data: data,
                value: id,
              });
            }}
            placeholder={destination.value ? destination : null}
          />
        </Col>
        {index > 0 && (
          <Col flex="none">
            <Button
              onClick={() =>
                dispatchUserData({
                  type: "REMOVE_DESTINATION",
                  value: id,
                })
              }
              danger
              type="primary"
              size="small"
            >
              Quitar
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default DraggableDestination;
